import React from 'react'
import HTMLText from './HTMLText'

import '../styles/settings-checkbox.scss'

function SettingsCheckbox({ label, ...props }) {
  return (
    <div className="account-settings-checkbox">
      <label>
        <input type="checkbox" className="account-settings-checkbox__input" {...props} />
        <div className="account-settings-checkbox__label">
          <HTMLText html={label} />
        </div>
      </label>
    </div>
  )
}

export default SettingsCheckbox
